/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
 
  const selectors$Ex = {
    expandable: '[data-expandable]',
    trigger: '[data-expandable-trigger]',
    body: '[data-expandable-body]' 
  };

  const attributes$ExU = {
    open: 'open', 
    height: 'expandable-height' 
  };

  class ExpandableElements extends HTMLElement {
    constructor() { 
      super();

      this.expandables = this.querySelectorAll(selectors$Ex.expandable);  
    }

    connectedCallback() { 
      this.expandables.forEach((expandable) => {
        const trigger = expandable.querySelector(selectors$Ex.trigger);
        const body = expandable.querySelector(selectors$Ex.body); 
 
        trigger.addEventListener('click', (event) => this.onExpandableClick(event));
 
      });
    }

    open(expandable) {
      if (expandable.getAttribute('open') == 'true') return;

      expandable.setAttribute('open', true);
      const body = expandable.querySelector(selectors$Ex.body);  
      this.setBodyHeight(body, body.scrollHeight);
    }

    close(expandable) {
      if (!expandable.hasAttribute('open')) return;

      const body = expandable.querySelector(selectors$Ex.body); 
      const height = expandable.getAttribute(attributes$ExU.height)

      this.setBodyHeight(body, height);
 
      expandable.removeAttribute(attributes$ExU.open);
      
    }

    setBodyHeight(body, contentHeight) {
     // console.log('setBodyHeight',body, contentHeight);
      body.style.height = contentHeight !== 'auto' && contentHeight !== '' ? `${contentHeight}px` : contentHeight;
      //brick__section
    }

    onExpandableClick(event) {
      event.preventDefault();

      const trigger = event.target.matches(selectors$Ex.trigger) ? event.target : event.target.closest(selectors$Ex.trigger);
      const expandable = trigger.closest(selectors$Ex.expandable);
      
      if (expandable.hasAttribute(attributes$ExU.open)) {
        this.close(expandable);
      } else {
        this.open(expandable);
      }
 
    }
  }
 
  if (!customElements.get('expandable-elements')) {   
    customElements.define('expandable-elements', ExpandableElements);
  }
 

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
